import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as retrieveProjectPortfolios from "./retrieveProjectPortfolios";
import * as createProjectPortfolio from "./createProjectPortfolio";
import * as removeProjectPortfolio from "./removeProjectPortfolio";
import * as assignProjectToPortfolio from "./assignProjectToPortfolio";
import * as removeProjectFromPortfolio from "./removeProjectFromPortfolio";
import * as editProjectPortfolio from "./editProjectPortfolio";

const initialState: State = {
  retrieveProjectPortfolios: retrieveProjectPortfolios.initialState,
  createProjectPortfolio: createProjectPortfolio.initialState,
  removeProjectPortfolio: removeProjectPortfolio.initialState,
  assignProjectToPortfolio: assignProjectToPortfolio.initialState,
  removeProjectFromPortfolio: removeProjectFromPortfolio.initialState,
  editProjectPortfolio: editProjectPortfolio.initialState,
};

const reduceState = combineStateReducer(initialState, {
  retrieveProjectPortfolios: retrieveProjectPortfolios.reduceState,
  createProjectPortfolio: createProjectPortfolio.reduceState,
  removeProjectPortfolio: removeProjectPortfolio.reduceState,
  assignProjectToPortfolio: assignProjectToPortfolio.reduceState,
  removeProjectFromPortfolio: removeProjectFromPortfolio.reduceState,
  editProjectPortfolio: editProjectPortfolio.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...retrieveProjectPortfolios.createSelector(
      () => getState().retrieveProjectPortfolios,
    ),
    ...createProjectPortfolio.createSelector(
      () => getState().createProjectPortfolio,
    ),
    ...removeProjectPortfolio.createSelector(
      () => getState().removeProjectPortfolio,
    ),
    ...assignProjectToPortfolio.createSelector(
      () => getState().assignProjectToPortfolio,
    ),
    ...removeProjectFromPortfolio.createSelector(
      () => getState().removeProjectFromPortfolio,
    ),
    ...editProjectPortfolio.createSelector(
      () => getState().editProjectPortfolio,
    ),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
